import React from 'react';
import {
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';

const QuotesNullView = () => {
  const { isMobile } = useQuoteContext();

  const {
    benefits, cardTitle,
    imageAlt, imageUrl, learnMoreText
  } = fallbackViewTexts;

  const cardBody = (
    <CardBody>
      <ul
        className="sui-list-disc sui-list-outside sui-ml-4 sui-mb-0 sui-pb-4"
      >
        {benefits?.map((benefit, index) => (
          <li key={index}>
            <Typography>{benefit}</Typography>
          </li>
        ))}
      </ul>
    </CardBody>
  );

  return (
    <div className="sui-@container sui-h-full">
      {isMobile ? (
        <div className="sui-h-full">
          <CompactNullView
            cardBody={cardBody}
            imageUrl={imageUrl}
            imageAlt={imageAlt}
            cardTitle={cardTitle}
            learnMoreText={learnMoreText}
          />
        </div>
      ) : (
        <div className="sui-h-full">
          <DesktopNullView
            cardBody={cardBody}
            imageUrl={imageUrl}
            imageAlt={imageAlt}
            cardTitle={cardTitle}
            learnMoreText={learnMoreText}
          />
        </div>
      )}
    </div>
  );
};

QuotesNullView.propTypes = {};
QuotesNullView.defaultProps = {};

export default QuotesNullView;
